export enum ElevenLabsVoiceId {
  Will = "bIHbv24MWmeRgasZH58o",
  Jessica = "cgSgspJ2msm6clMCkdW9",
  Liam = "TX3LPaxmHKxFdv7VOQHJ"
}

export interface VoiceOption {
  id: ElevenLabsVoiceId;
  name: string;
  gender: 'Male' | 'Female';
  accent: string;
  age: string;
  characteristics: string;
  sampleAudioUrl?: string;
}

export const ELEVEN_LABS_VOICES: VoiceOption[] = [
  {
    id: ElevenLabsVoiceId.Will,
    name: 'Will',
    gender: 'Male',
    accent: 'American',
    age: '24 years old',
    characteristics: 'Deeper tone, calming, professional'
  },
  {
    id: ElevenLabsVoiceId.Jessica,
    name: 'Jessica',
    gender: 'Female',
    accent: 'American',
    age: '27 years old',
    characteristics: 'Soothing, friendly, professional'
  },
  {
    id: ElevenLabsVoiceId.Liam,
    name: 'Liam',
    gender: 'Male',
    accent: 'American',
    age: '29 years old',
    characteristics: 'Soft, professional'
  }
];
